<template>
  <v-container class="grey lighten-5" fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="basil"
          grow>
          <v-tab>
            Utilizatori
          </v-tab>
          <v-tab>
            FAQ
          </v-tab>
          <v-tab>
            Resurse
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <admin-users />
          </v-tab-item>
          <v-tab-item>
            <admin-faq />
          </v-tab-item>
          <v-tab-item>
            <admin-resources />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AdminUsers from "@/components/AdminUsers.vue";
import AdminFaq from "@/components/AdminFaq.vue";
import AdminResources from "@/components/AdminResources.vue";

export default {
  name: "admin",

  components: {
    "admin-users": AdminUsers,
    "admin-faq": AdminFaq,
    "admin-resources": AdminResources
  },

  data: () => ({
    tab: null
  })
};
</script>
